/**
 * Follow-ups — `docs/API.md` §8. Fully implemented server-side now:
 * `salescrmapi/src/modules/followups`. Kept separate from `crm.activity` so a
 * missed follow-up can be re-planned without erasing the record that it was
 * missed.
 */
import apiClient, { ifMatch } from './axiosClient.js';

/** @param {object} [params] `{ status, assigned_to_id, due_before, overdue, lead_id, opportunity_id, account_id }` */
export async function listFollowUps(params = {}) {
  const { data } = await apiClient.get('/follow-ups', { params });
  return data;
}

/** @param {object} payload at minimum `{ due_at }` plus one of lead_id/opportunity_id/account_id */
export async function createFollowUp(payload) {
  const { data } = await apiClient.post('/follow-ups', payload, { headers: { 'Idempotency-Key': crypto.randomUUID() } });
  return data;
}

export async function updateFollowUp(id, patch, rowVersion) {
  const { data } = await apiClient.patch(`/follow-ups/${id}`, patch, { headers: ifMatch(rowVersion) });
  return data;
}

export async function completeFollowUp(id) {
  const { data } = await apiClient.post(`/follow-ups/${id}/complete`);
  return data;
}

/** @param {string} id @param {{until:string, reason?:string}} payload */
export async function snoozeFollowUp(id, payload) {
  const { data } = await apiClient.post(`/follow-ups/${id}/snooze`, payload);
  return data;
}
